import { Link as GatsbyLink } from 'gatsby';
import { PropTypes } from 'prop-types';
import React from 'react';

import ExternalLink from './ExternalLink';

// trailing slash check
const getUrl = (_url) => {
  if (!_url) return '/';

  if (_url.includes('.php')) return _url;

  let url = _url;
  if (url[url.length - 1] !== '/') url += '/';
  return url;
};

const Link = ({ ariaLabel, children, className, style, to }) => {
  const url = getUrl(to);
  return url.includes('https') || url.includes('.com') ? (
    <ExternalLink
      aria-label={ariaLabel}
      className={className}
      data-component-id="external_link"
      data-enable-tracking
      href={url}
      style={style}
    >
      {children}
    </ExternalLink>
  ) : (
    <GatsbyLink
      aria-label={ariaLabel}
      className={className}
      data-enable-tracking
      style={style}
      to={url}
    >
      {children}
    </GatsbyLink>
  );
};

Link.propTypes = {
  ariaLabel: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
    PropTypes.node,
  ]),
  className: PropTypes.string,
  style: PropTypes.object,
  to: PropTypes.string,
};

export default Link;
